import { t } from './i18n';

export const SELECTORS = {
    container: '.appointment-cancel__container',
    body: '.appointment-cancel__body',
    card: '.appointment-cancel__body .card',
    icon: '.appointment-cancel__body .icon',
    checkIconWrapper: '.appointment-cancel__container .icon .custom-check-icon-wrapper',
    informationCard: '.appointment-cancel__body .information .card',
    staffInfo: '.appointment-cancel__container .time-staff__info .staff__info',
    timeInfo: '.appointment-cancel__container .time-staff__info .time__info',
    dateInfo: '.appointment-cancel__container .date__info',
    actionDiv: '.appointment-cancel__container .card .action',
    appointmentButtons: '.appointment-cancel__container .appointment-confirm-single',
    title: '.appointment-cancel__body .title',
    confirmBtn: '#confirm-appointment-btn',
    cancelLink: '#cancel-appointment-link',
    logo: '.appointment-cancel__container .appointment__logo',
    pendingBanner: '.appointment-cancel__container .pending-approval-banner',
    cancelledBanner: '.appointment-cancel__container .cancelled-appointment-banner'
};

export const MESSAGES = {
    errors: {
        get eventIdNotFound() { return t('error_event_id_not_found'); },
        get locationUndefined() { return t('error_location_undefined'); },
        get cancelFailed() { return t('cancel_failed'); },
        get copyFailed() { return t('error_copy_failed'); },
        get invalidResponse() { return t('error_invalid_response'); },
    },
    success: {
        get addressCopied() { return t('address_copied'); },
        get cancelAppointment() { return t('cancel_success'); }
    },
    ui: {
        get processing() { return t('processing'); },
        get cancel() { return t('cancel'); },
        get cancelled() { return t('cancelled'); },
        get appointmentCancelled() { return t('appointment_cancelled_title'); },
        get bookNewAppointment() { return t('book_new_appointment'); }
    },
    banner: {
        get cancelled() { return t('cancelled_banner_title'); },
        get cancelledDescription() { return t('cancelled_banner_desc'); }
    }
};

export const BUTTON_CONFIG = {
    bookNew: {
        id: 'book-new-appointment-btn',
        className: 'button--no-style book-new-button book-new-button-large',
        get text() { return t('book_new_appointment'); },
        get loadingText() { return t('processing'); },
        type: 'button'
    }
};

export const APPOINTMENT_STATUS = {
    REQUEST: 'request',
    CONFIRMED: 'confirmed',
    COMPLETE: 'complete',
    CANCELLED: 'cancelled'
};

export const PARTICIPANT_TYPES = {
    LEAD: 'App\\Models\\Lead',
    STAFF: 'App\\Models\\Staff'
};

export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    SERVER_ERROR: 500
};

export const COLORS = {
    error: '#e74c3c',
    success: '#11b654',
    cancel: '#e74c3c'
};

export const TIMEOUTS = {
    defaultToast: 3000,
    buttonReset: 2000
};
